export default __webpack_public_path__ + "static/media/error.18bdf66a.jpg";